module.exports = __webpack_public_path__ + "img/davis.f6d0a422.png";